import Cookies from 'js-cookie';
import { confirmDialogStore } from '@qbot-chat/qbot-uikit';

import { rSocket } from '../store/FrontChatStore';
import { navigateReplace } from './HistoryHelper';
import { PATH, ratingPath } from '../const/path';
import { COOKIE_KEY_CHANNEL_ID, COOKIE_KEY_USER_KEY } from '../const/AppConst';

// 상담 화면들이 공유하는 절차. 훅이 아닌 일반 함수라 클래스 컴포넌트에서도 쓴다.

// 상담 종료 확인 → 종료 → 평가 화면 이동.
// 회사별 ChatView 4종 × 상담사 연결 전/후 2곳 = 8곳에서 같은 코드를 쓰던 절차
export const openCloseConfirm = (store) => {
  confirmDialogStore.open({
    title: '종료',
    summary: '상담을 종료하시겠습니까?',
    onOk: () => {
      store.close(store.channelId).then(() => {
        navigateReplace(ratingPath(store.channelId));
      });
    },
  });
};

// 「상담 재시작」 진입 URL. 루트로 들어가면 App.js 가 /loading 으로 넘긴다
export const buildRestartUrl = () =>
  `/?user_id=${Cookies.get(COOKIE_KEY_USER_KEY)}&chnlId=${Cookies.get(
    COOKIE_KEY_CHANNEL_ID,
  )}`;

// 종료 화면 문구. 평가를 거쳤는지에 따라 다른 메시지를 쓴다
export const fetchClosedMessage = async (isRating) => {
  const { data } = await rSocket.requestChatApi('/app/setting');
  return isRating ? data?.chatRatingClosedMessage : data?.chatClosedMessage;
};

// 평가 화면 진입 게이트. 고객 평가가 꺼져 있으면 종료 화면으로 보낸다.
// RatingView 4종이 같은 판정을 각자 하던 것을 한 곳으로 모음
export const applyRatingGate = async ({ onMessage, onAllowed }) => {
  const { data } = await rSocket.requestChatApi('/app/setting');
  onMessage(data?.chatRatingMessage);

  if (!data?.isEvaluationableByCustomer) {
    navigateReplace(PATH.CLOSE);
    return;
  }
  onAllowed();
};

// 회사 표시 정보 — 서버 응답(companyStore) 우선, 없으면 레지스트 기본값.
// 로고는 정적 기본 이미지가 없어 null 일 수 있다. 호출부의 널가드는 그대로 둔다
export const resolveCompanyDisplay = (company, registryEntry) => ({
  name: company?.companyName ?? registryEntry.name,
  symbolUrl: company?.symbolLogo?.fullUrl ?? null,
  characterUrl:
    company?.logoFile?.fullUrl ?? company?.symbolLogo?.fullUrl ?? null,
});
